export const themeBtnsHandler = () => {
  const themeModBtns = document.querySelectorAll('.dark-mode__icon');
  const themeModBtnsWrapper = document.querySelector('.dark-mode');

  if (!themeModBtns.length) {
    return;
  }

  const modeClass = localStorage.getItem('selectedTheme');

  const changeSecondClass = (element, newClass) => {
    const classes = Array.from(element.classList);

    if (classes.length >= 2) {
      const secondClass = classes[1];
      element.classList.remove(secondClass);
      element.classList.add(newClass);
    }
  };

  changeSecondClass(themeModBtnsWrapper, modeClass);

  const changeCommentsColorOnToggle = () => {
    const rootElem = document.querySelector('html[data-theme]');
    const theme = rootElem.getAttribute('data-theme');

    const commentsSection = document.querySelector('#ghost-comments-root');

    if (commentsSection) {
      const commentsScript = document.querySelector('script[data-color-scheme]');
      commentsScript.setAttribute('data-color-scheme', theme);
    }
  };

  themeModBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const themeMod = btn.getAttribute('data-theme-mode');
      changeSecondClass(themeModBtnsWrapper, themeMod);
      applyTheme(themeMod);
      changeCommentsColorOnToggle();
    });
  });

  window.addEventListener('storage', (event) => {
    if (event.key === 'selectedTheme') {
      if (event.newValue === null) {
        localStorage.setItem('selectedTheme', 'system');
      }

      applyTheme(event.newValue || 'system');
    }
  });
};
